/**
 * Utility functions for admin-related functionality
 */

/**
 * Checks if the current user has admin role by decoding the JWT token
 * @returns {boolean} True if user is admin, false otherwise
 */
export const isUserAdmin = () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    const userRoles = payload.roles || [];
    return userRoles.includes('ADMIN');
  } catch (error) {
    console.error('Error decoding token for admin check:', error);
    return false;
  }
};

/**
 * Gets the appropriate back button text based on user role
 * @returns {string} "Meys Bereich" for admin users, "Mein Bereich" for regular users
 */
export const getBackButtonText = () => {
  return isUserAdmin() ? 'Meys Bereich' : 'Mein Bereich';
};

/**
 * Gets the appropriate navigation path based on user role
 * @returns {string} "/meys-page" for admin users, "/mypage" for regular users
 */
export const getBackNavigationPath = () => {
  return isUserAdmin() ? '/meys-page' : '/mypage';
};
